
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="mail-dialog">

     <vnc-header class="message" title="{{ 'ATTACH_FROM_BRIEFCASE' | translate }}" type="title-close" size="l"
        (onCloseClick)="close()" [showCloseIcon]="true" closeIconToolTip="{{ 'CLOSE' | translate }}">
    </vnc-header>

    <div class="mail__dialog-body mail__dialog-body--pad briefcase-attach-body">
        <div class="content">
            <div class="search_div">
                <div class="searchField">
                    <vnc-input
                        [form]="searchControl"
                        [showClear]="true"
                        leadingIconName="mdi-magnify"
                        (leadingIconClick)="searchMessages()"
                        placeholder="{{ 'SEARCH_DOT' | translate }}"
                        size="m"
                        type="text">
                    </vnc-input>
                </div>

                <div class="pagging">
                    <button mat-button (click)="loadPreviousMail()" [disabled]="offset===0">
                        <mat-icon class="disable-select">keyboard_arrow_left</mat-icon>
                    </button>
                    <span *ngIf="limit!==0">{{offset + 1 }} - {{limit + offset}}</span>
                    <button mat-button (click)="loadNextMail()" [disabled]="isMoreMessage">
                        <mat-icon class="disable-select">keyboard_arrow_right</mat-icon>
                    </button>
                </div>
            </div>
            <div class="tree_email_div">
                <div class="tree_div">
                    <cdk-virtual-scroll-viewport style="height: 100%;"
                        [itemSize]="50">
                        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="folder-tree">
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                                <li class="mat-tree-node" (click)="folderItem(node)"
                                    [class.selected-class]="selectedFolder !== null && node.id === selectedFolder.id">
                                    <button mat-icon-button disabled></button>
                                    <span *ngIf="node.id !==''" style="height: 22px;">
                                        <ng-container *ngTemplateOutlet="folderIcon; context: { color: node.rgb }" ></ng-container>
                                    </span>
                                    <span class="folder-name-text">
                                        {{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}
                                    </span>
                                </li>
                            </mat-tree-node>
                            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                                <li>
                                    <div class="mat-tree-node" (click)="folderItem(node)"
                                        [class.selected-class]="selectedFolder !== null && node.id === selectedFolder.id">
                                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                            </mat-icon>
                                        </button>
                                        <span *ngIf="node.id !==''" style="height: 22px;">
                                            <ng-container *ngTemplateOutlet="folderIcon; context: { color: node.rgb }" ></ng-container>
                                        </span>
                                        <span class="folder-name-text">
                                            {{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}
                                        </span>
                                    </div>
                                    <ul [class.folder-tree-invisible]="!treeControl.isExpanded(node)">
                                        <ng-container matTreeNodeOutlet></ng-container>
                                    </ul>
                                </li>
                            </mat-nested-tree-node>
                        </mat-tree>
                    </cdk-virtual-scroll-viewport>
                </div>
                <div class="email_list">
                    <mat-list class="briefcase-list-items-view" *ngIf="files.length>0">
                        <div id="file-{{ file.id}}" *ngFor="let file of files">
                            <mat-list-item class="briefcase-item-info" [ngClass]="{'is-selected': isSelectedEmailMessage(file)}">
                                <div class="briefcase-checkbox" (click)="$event.stopPropagation();selectEmail(file, i, $event)">
                                    <div *ngIf="file.icon.isImage === true" class="file-icons">
                                        <img *ngIf="file?.url" [src]="prepareUrl(file?.url)">
                                        <mat-icon *ngIf="!file?.url" class="mdi-28px" fontSet="mdi" fontIcon="mdi-image"></mat-icon>
                                    </div>
                                    <div *ngIf="file.icon.isImage === false" class="file-icons">
                                        <ng-container *ngIf="file.icon.icon === 'mdi-file'" [ngTemplateOutlet]="fileIcon"></ng-container>
                                        <mat-icon class="mdi-28px" *ngIf="file.icon.icon !== 'mdi-file'" fontSet="mdi" fontIcon="{{file.icon.icon}}"></mat-icon>
                                    </div>
                                </div>
                                <div class="briefcase-information" fxLayout="row" fxFlex="100" fxFlexFill>
                                <div fxFlex="75" class="briefcase-information-left">
                                    <div class="filename">
                                        <div class="filename-div disable-select" (click)="selectEmail(file, i, $event)">{{file.name}}</div>
                                        <div class="tag-span" *ngIf="file?.tn" (click)="selectEmail(file, i, $event)">
                                            <mat-icon *ngIf="file.tn.split(',').length === 1" [style.color]="getTagColor(file?.tn)" class="icon-tags disable-select">local_offer</mat-icon>
                                            <img *ngIf="file.tn.split(',').length > 1" [src]="rainbowTagIcon" class="icon-tags rainbow-colored-tag disable-select">
                                        </div>
                                        <div *ngIf="file.f &&  file.f.indexOf('/') !== -1" class="expand-down-arrow">
                                            <mat-icon *ngIf ="!file.isExpand" (click)="$event.stopPropagation();$event.preventDefault();toggleItem(file , true)" class="mdi-16px icon-expand disable-select" fontSet="mdi" fontIcon="mdi-menu-right"></mat-icon>
                                            <mat-icon *ngIf ="file.isExpand" style="font-size:16px;height: 14px;display: block;" (click)="$event.stopPropagation();$event.preventDefault();toggleItem(file , false)" class="disable-select">arrow_drop_up</mat-icon>
                                        </div>
                                    </div>
                                    <div class="file-creator disable-select" (click)="selectEmail(file, i, $event)">{{file.cr}}</div>
                                    </div>
                                    <div fxFlex="25" class="breiefcase-list-item-time-size" fxFlexFill (click)="selectEmail(file, i, $event)">
                                        <div class="time disable-select">{{ file.d | vpDisplayTime: 'MMM DD'}}</div>
                                        <div class="size disable-select" *ngIf="file.s === 0">
                                            0 B
                                        </div>
                                        <div class="size disable-select" *ngIf="file.s !== 0">
                                            {{file.s | vpFormatFileSize:false}}
                                        </div>
                                        <div *ngIf="file.loid && file.loid !== ''" class="disable-select">
                                            <mat-icon class="disable-select">lock</mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                            <mat-list *ngIf="file.isExpand" class="revision_list">
                                    <div *ngFor="let revision of file.revisions; index as j;">
                                        <!-- <mat-list-item>{{revision.cr}}</mat-list-item> -->
                                        <mat-list-item class="briefcase-item-info"  [ngClass]="{'is-selected': isSelectedEmailMessage(revision)}" (click)="selectEmail(revision, i, $event)">
                                                <div class="briefcase-checkbox" (click)="$event.stopPropagation();">
                                                    <div *ngIf="revision.icon.isImage === true" class="file-icons">
                                                        <img *ngIf="revision?.url" [src]="prepareUrl(revision?.url)">
                                                        <mat-icon *ngIf="!revision?.url" class="mdi-28px" fontSet="mdi" fontIcon="mdi-image"></mat-icon>
                                                    </div>
                                                    <div *ngIf="revision.icon.isImage === false" class="file-icons">
                                                        <mat-icon class="mdi-28px" fontSet="mdi" fontIcon="{{revision.icon.icon}}" class="disable-select"></mat-icon>
                                                    </div>
                                                </div>
                                            <div class="briefcase-information" fxLayout="row" fxFlex="100" fxFlexFill>
                                                <div fxFlex="75" class="briefcase-information-left">
                                                    <div class="filename">
                                                        <div class="filename-div disable-select">#{{revision.ver}}</div>
                                                        <div class="tag-span" *ngIf="revision?.tn">
                                                            <mat-icon *ngIf="revision.tn.split(',').length === 1" [style.color]="getTagColor(revision?.tn)" class="icon-tags disable-select">local_offer</mat-icon>
                                                            <img *ngIf="revision.tn.split(',').length > 1" [src]="rainbowTagIcon" class="icon-tags rainbow-colored-tag disable-select">
                                                        </div>
                                                    </div>
                                                    <div class="file-creator disable-select">{{revision.cr}}</div>
                                                    </div>
                                                    <div class="breiefcase-list-item-time-size">
                                                        <div class="time disable-select revision-time" style="white-space: nowrap;">{{ revision.d | vpDisplayTime:'MMM DD, YYYY LT'}}</div>
                                                        <div class="size disable-select" *ngIf="revision.s === 0">
                                                            0 B
                                                        </div>
                                                        <div class="size disable-select" *ngIf="revision.s !== 0">
                                                            {{revision.s | vpFormatFileSize:false}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </mat-list-item>
                                    </div>
                            </mat-list>
                        </div>
                    </mat-list>
                </div>
            </div>
        </div>
    </div>
    <vnc-footer class="calendar-menu-actio desktop_view" [secondaryLabel]="'CANCEL_MAIL_LABEL' | translate | uppercase"
        [primaryLabel]="'ATTACH_LBL' | translate | uppercase" [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb') }"
        [type]="'secondary-primary'" [color]="'white'" (onSecondaryClick)="close()"
        [isPrimaryDisabled]="selectedEmails.length === 0" (onPrimaryClick)="attachMessages()">
    </vnc-footer>
</div>

<ng-template #folderIcon let-color="color">
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/folder-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Icon-24px" transform="translate(2.000000, 4.000000)" [attr.fill]="color">
              <path d="M7.00922203,0 C7.49995184,0 8.18025928,0.262988878 8.59481703,0.605726148 L8.71075654,0.71075654 L9.28924346,1.28924346 C9.65129486,1.65129486 10.3113868,1.94247309 10.8421188,1.99242242 L10.9970301,2 L18,2 C19.05,2 19.9177686,2.82004132 19.9944872,3.85130541 L20,4 L20,14 C20,15.05 19.1799587,15.9177686 18.1486946,15.9944872 L18,16 L2,16 C0.95,16 0.082231405,15.1799587 0.00551277235,14.1486946 L0,14 L0.01,2 C0.01,0.95 0.820929752,0.082231405 1.85136551,0.00551277235 L2,0 L7.00922203,0 Z M7.00922203,2 L2.00999931,2.00166667 L2,14 L18,14 L18,4 L10.9970301,4 C9.98506984,4 8.81419501,3.54226902 8.03565409,2.85431634 L7.8750299,2.70345702 L7.29654298,2.1249701 L7.27022108,2.10994272 L7.0847011,2.02870664 L7.00922203,2 Z" id="Shape" [attr.fill]="color"></path>
          </g>
      </g>
  </svg>
</ng-template>
<ng-template #fileIcon>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/file-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M13.5857864,2 C13.8510029,2 14.1053568,2.10535684 14.2928932,2.29289322 L19.7071068,7.70710678 C19.8946432,7.89464316 20,8.14899707 20,8.41421356 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L13.5857864,2 Z M10.999,3.999 L6,4 L6,20 L18,20 L18,10 L14,10 C12.4023191,10 11.0963391,8.75108004 11.0050927,7.17627279 L11,7 L10.999,3.999 Z M17.172,8 L13.171,4 L12.999,3.999 L13,7 C13,7.51283584 13.3860402,7.93550716 13.8833789,7.99327227 L14,8 L17.172,8 Z" id="Combined-Shape" fill="#8B96A0"></path>
        </g>
    </svg>
</ng-template>